export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAILURE = "CREATE_ORDER_FAILURE";

export const ORDER_DETAIL_REQUEST = "ORDER_DETAIL_REQUEST";
export const ORDER_DETAIL_SUCCESS = "ORDER_DETAIL_SUCCESS";
export const ORDER_DETAIL_FAILURE = "ORDER_DETAIL_FAILURE";

export const UPDATE_ORDER_PAYMENT_REQUEST = "UPDATE_ORDER_PAYMENT_REQUEST";
export const UPDATE_ORDER_PAYMENT_SUCCESS = "UPDATE_ORDER_PAYMENT_SUCCESS";
export const UPDATE_ORDER_PAYMENT_FAILURE = "UPDATE_ORDER_PAYMENT_FAILURE";

export const RESET_CREATE_ORDER = "RESET_CREATE_ORDER";
export const RESET_ALL_ACTIONS = "RESET_ALL_ACTIONS";
